import React from 'react';
import CartContainer from '../containers/cart_container';

const CartContext = React.createContext(new CartContainer());

export default CartContext;
